<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />

    <template v-if="data && data.baseData &&!allRight">
      <div class="infoRect">
        <van-row>
          <van-col span="12">
            <!-- <i class="iconfont iconbi" /> -->{{ questionIndex+1 }}/{{ selectQuestionList.length }}
          </van-col>
          <van-col span="12">
            <van-checkbox v-if="false" v-model="justError" style="float:right" shape="square" :checked-color="GetDiveMainBack()" @change="onChangeType">只看错题</van-checkbox>
          </van-col>
        </van-row>
      </div>
      <div class="questionRect">
        <div v-html="questionData.isMultiple?'<b>[多选]</b> '+questionData.question:questionData.question" />
      </div>

      <div class="answerRect">
        <div v-for="answer in questionData.answer" :key="answer.answerId" class="answer van-radio">
          <div v-if="!answer.isSelect" class="van-radio__icon van-radio__icon--round">
            <i class="van-icon van-icon-success" />
          </div>
          <div v-if="answer.isSelect" class="van-radio__icon van-radio__icon--round van-radio__icon--checked">
            <i class="van-icon van-icon-success" :style="'border-color:'+GetDiveMainBack()+'; background-color: '+GetDiveMainBack()" />
          </div>
          <span class="van-radio__label" :style="answer.isRight?'color:#07c160':''">{{ answer.body }} </span>
        </div>
      </div>
      <div v-if="questionData.analysis" class="analysisRect"><b>题目解析:</b>{{ questionData.analysis }}</div>
      <div class="emptyRect" />
      <div class="buttonRect">
        <div class="buttons">
          <van-button class="button" type="primary" square size="small" style="width:33%;" :disabled="questionIndex<=0" :color="GetDiveMainBack()" @click="onUpQuestion">上一题</van-button>
          <van-button class="button" type="primary" square size="small" style="width:33%;" :color="GetDiveMainBack()" @click="onClickList">列表</van-button>
          <van-button :disabled="questionIndex+1>=selectQuestionList.length" class="button" type="primary" square size="small" style="width:33%;" :color="GetDiveMainBack()" @click="onDownQuestion">下一题</van-button>

        </div>
      </div>
    </template>
    <van-popup v-model="showList" class="ListRect">
      <div class="title">题目列表</div>
      <div class="QuestionRect">
        <div v-for="(question,index) in selectQuestionList" :key="question.questionId" :class="question.isRight?'rect success':'rect error'" @click="onSelectQuestion(index)">
          <span>{{ question.id }}</span>
        </div>
      </div>
    </van-popup>
    <fullError v-if="allRight" title="全部正确" about="您太厉害了,没有错题!" native-str="" background-color="#f5f5f5" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Checkbox, CountDown, Loading, Tag, Popup, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import fullError from '@/components/fullError'
export default {
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CountDown.name]: CountDown,
    [Loading.name]: Loading,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    TopBar,
    fullError
  },
  data() {
    return {
      titleTop: '',
      title: '错题回顾',
      backurl: '/dive',
      id: undefined,
      data: {
        baseData: undefined,
        questionList: []
      },
      selectQuestionList: [],
      questionData: undefined,
      questionSelect: [],
      questionIndex: 0,
      saveSelectListStr: undefined,
      showList: false,
      justError: true,
      allRight: false
    }
  },
  created() {
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.init()
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/DiveLearn/getExamError',
        method: 'post',
        params: {
          id: this.id
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        // 判断是否全对
        this.allRight = true
        this.data.questionList.forEach(item => {
          if (!item.isRight) {
            this.allRight = false
          }
        })
        var i = 1
        this.data.questionList.forEach(item => {
          item.id = i++
        })
        this.onChangeType()
      })
    },

    onUpQuestion() {
      if (this.questionIndex <= 0) {
        return
      }
      this.questionIndex--
      this.onLoadQuestion()
    },
    onDownQuestion() {
      if (this.questionIndex + 1 >= this.data.baseData.totalNum) {
        return
      }
      if (this.questionIndex + 1 >= this.selectQuestionList.length) {
        return
      }
      this.questionIndex++
      this.onLoadQuestion()
    },
    onLoadQuestion() {
      this.questionSelect = undefined
      this.questionData = this.selectQuestionList[this.questionIndex]
      if (this.questionData) {
        this.questionSelect = this.questionData.select
      }
    },
    onSelectQuestion(index) {
      this.showList = false
      this.questionIndex = index
      this.onLoadQuestion()
    },
    onquestionSelectChange() {
      console.log('onquestionSelectChange', this.questionSelect)
      this.questionData.select = this.questionSelect
    },
    onClickList() {
      this.showList = true
    },
    onChangeType() {
      if (this.justError) {
        this.selectQuestionList = this.data.questionList.filter(item => item.isRight === false)
      } else {
        this.selectQuestionList = this.data.questionList
      }
      this.questionIndex = 0
      this.onLoadQuestion()
    }
  }
}
</script>
<style scoped>
.infoRect{
  background-color: #fff;
  padding: 1em;
  color: #999;
  font-size: 0.9em;
}
.questionRect{
  background-color: #fff;
  padding: 0 1em 1em 1em;
  font-size: 0.9em;
}
.answerRect{
background-color: #fff;
padding:  0 1em;
}
.answerRect .answer{

  font-size: 0.9em;
  padding: 0.5em 0;
  border-bottom: 1px solid #f5f5f5;
}
.answerRect .answer:last-child{
  border-bottom: none;
}
.analysisRect{
  background-color: #fff;
  font-size: 0.9em;
  padding: 1em;
  color: #999;
}
.emptyRect{
  height: 4em;
  }
.buttonRect{
    position: fixed;
    left: 0;
    bottom: 0;
    height: 4em;
    width: 100%;
    border-top: 1px solid #f5f5f5;
    background-color: #fff;

}
.buttonRect .buttons{
    padding: 1em 1em;
}
.buttonRect .button:first-child{
  border-top-left-radius: 2em;
  border-bottom-left-radius: 2em;
}
.buttonRect .button:last-child{
  border-top-right-radius: 2em;
  border-bottom-right-radius: 2em;
}
.buttonRect .button:nth-child(2)
{
  margin: 0 1px;
}
.examStartRect{
  background-color: #fff;
  padding:1em;
}
.examStartRect .title{
  text-align: center;
  font-weight: 700;
}
.examStartRect .about{
  font-size: 0.9em;
  margin: 0.5em 0;
}
.examStartRect .buttons{

}
.buttonMore{
  color: #999;
  font-size: 0.8em;
  text-align: center;
  margin: 0.5em 0;
}
.ListRect{
  width: calc(100vw - 2em);
  background-color: #fff;
  border-radius: 0.4em;
}
.ListRect .title{
  text-align: center;
  padding: 0.3em 0;
  border-bottom: 1px solid #f5f5f5;
}
.ListRect .QuestionRect{
  display: flex;
  flex-wrap: wrap;
  height: 50vh;
  overflow-y: scroll;
}
.ListRect .QuestionRect .rect{
  width: 2em;
  height: 2em;
  border: 1px solid #f5f5f5;
  margin: 0.2em;
  line-height: 2em;
  text-align: center;
}
.ListRect .QuestionRect .select{
  font-weight: 700;
}
.ListRect .QuestionRect .selectAnswer{
  font-weight: 700;
}
.ListRect .QuestionRect .rect span{
font-size: 0.8em;
}
.ListRect .QuestionRect .success{
 border: 1px solid #07c160;
}
.ListRect .QuestionRect .error{
   border: 1px solid #ee0a24;
}
</style>
